export default __webpack_public_path__ + "locales/es/Settings.json?hash=b42241ed7dee6f0ab5bfa9842b5111f7";